import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/functions";
import "firebase/compat/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBPvkhHg-QcUkKpUy64u3UVSC8bewegAaE",
  authDomain: "giuviprojects.firebaseapp.com",
  projectId: "giuviprojects",
  storageBucket: "giuviprojects.appspot.com",
  messagingSenderId: "858495750489",
  appId: "1:858495750489:web:85b7e61132a1a16976bc48",
};

// init app
firebase.initializeApp(firebaseConfig);

// init firestore database
const database = firebase.firestore();

// init autenticazione firebase (guarded for test/non-browser environments)
let autenticazione = null;
if (typeof window !== "undefined" && process.env.NODE_ENV !== "test") {
  autenticazione = firebase.auth();
}
// Provide a minimal mock in test environment to satisfy consumers
if (process.env.NODE_ENV === "test" && !autenticazione) {
  autenticazione = {
    onAuthStateChanged: (cb) => {
      cb(null);
      return () => {};
    },
  };
}

// init storage
const filesCloud = firebase.storage();

// init cloudFunctions
const functions = firebase.app().functions("us-central1");

// init firebase Analytics (guarded for test/non-browser environments)
let analytics = null;
if (typeof window !== "undefined" && process.env.NODE_ENV !== "test") {
  analytics = firebase.analytics();
}

// timestamp
const timestamp = firebase.firestore.Timestamp;

export {
  database,
  autenticazione,
  timestamp,
  filesCloud,
  functions,
  analytics,
};
